import React from "react";
import DefaultLayout from "../../layout/DefaultLayout";
import BreadcrumbTwo from "../../components/Breadcrumbs/BreadcrumbTwo";

import CashAdjustmentSessionCard from "../../components/CashAdjustment/CashAdjustmentSessionCard";
import CashAdjustmentHistory from "../../components/CashAdjustment/CashAdjustmentHistory";
import CashAdjustmentModal from "../../components/CashAdjustment/CashAdjustmentModal";

const CashAdjustmentPage: React.FC = () => {

  return (

    <DefaultLayout>

      <BreadcrumbTwo />

      <div className="space-y-6">

        {/* Sesión actual */}
        <CashAdjustmentSessionCard />

        {/* Historial de ajustes */}
        <CashAdjustmentHistory />

      </div>

      {/* Modal ajuste */}
      <CashAdjustmentModal />

    </DefaultLayout>

  );

};

export default CashAdjustmentPage;